window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 sizemsg.style.visibility="hidden";
 linkmsg.innerHTML="カラーを選択してください";
}


// サイズオーダー
function checkBtn(){
 var idCloth = document.getElementsByName( "candy_tab" ) ;
 var strCloth = "";
 var i=0;
 for ( strCloth="", i=idCloth.length; i--; ) {
  if ( idCloth[i].checked ) {
   strCloth = idCloth[i].id.slice(4);
   break ;
  }
 }
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor=""
 for (strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i].id ;
   break ;
  }
 }
  var idOption = document.getElementsByName( "option" ) ;
 var strOption=""
 for (strOption="", i=idOption.length; i--; ) {
  if ( idOption[i].checked ) {
   strOption = idOption[i].id ;
   break ;
  }
 }

var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";
 if(strCloth.slice(0,2)!=strColor.slice(0,2)){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else if(strCloth.slice(0,2)=="mo"&&strColor.slice(0,2)=="mo"){
  if(strCloth.slice(0,3)!=strColor.slice(0,3)){
   linkmsg.style.visibility="visible";
   strErrmsg="カラーを選択してください";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =true;
     }else{
   linkmsg.style.visibility="hidden";
   linkmsg.innerHTML="";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =false;
     }
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}


/*内容リセット*/
function checkOption(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
 linkmsg.style.visibility="hidden";
}


function changeMsg(){
    var intHaba=document.getElementById("haba").value;
    sizemsg.style.visibility="hidden";
    checkOption();
    if (intHaba==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intHaba < 40 || intHaba > 190){document.getElementById("sizemsg").innerHTML = "<p>※ 幅40cm未満・幅190cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>"
 sizemsg.style.visibility="hidden";
}


const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,cloth,option){
this.url=url;this.haba=haba;this.cloth=cloth;this.option=option;}
function searchURL(strHaba,strCloth,strOption){
var strErr;
var intHaba=document.getElementById("haba").value
intHaba=parseInt(intHaba);

//幅・奥行チェック
if (intHaba < 40){
 strErr="幅40cm未満";
}else if (intHaba > 190){
  strErr="幅191cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}

//幅サイズ成形
switch(strHaba.length){
 case 2:
  if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
   strHaba ="100";
  }else if(strHaba.slice(-1) !="0"){
   strHaba=parseInt(strHaba.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strHaba.slice(-1)=="0"){
   
  }else{
  strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
  }
  break;
} 

//ベース価格
var basePrice = [48000];
var addPrice = [4000];
var sellPrice;
var i=0
var b=0

  mulHaba=(parseInt(strHaba)-40)/10;
  //▼幅40cmなら
  if(strHaba == 40){
    if(strCloth=="leather" || strCloth=="chappy" || strCloth=="magic" || strCloth=="moq"){
    sellPrice = basePrice[i];
    }else{alert("生地を選択してください"); return false; }
  }
  //▼他サイズなら
  else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="magic" || strCloth=="moq"){
    sellPrice =  parseInt(basePrice[i])+(parseInt(addPrice[b])*parseInt(mulHaba));
    }else{alert("生地を選択してください"); return false; }
  return sellPrice;
}

/*リストから商品URLを取得*/
function checkURL(strHaba,strCloth,strOption){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].cloth==strCloth && goods[i].option==strOption){
return goods[i].url;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 checkOption()
 
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strHaba=document.getElementById("haba").value;
var idCloth = document.getElementsByName( "candy_tab" ) ;
var idColor = document.getElementsByName( "colortype" ) ;
var idOption = document.getElementsByName( "option" ) ;
var strCloth = "";
var strColor = "";
var strOption = "";
var i=0;
var c=0;
for ( strCloth="", i=idCloth.length; i--; ) {
 if ( idCloth[i].checked ) {
  strCloth = idCloth[i].id.slice(4);
  var valueCloth = idCloth[i].value ;
  break ;
 }
}
for ( strColor="", a=idColor.length; a--; ) {
 if ( idColor[a].checked ) {
  strColor = idColor[a].id ;
  var valueColor = idColor[a].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var valueOption = idOption[c].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (strColor==false){
alert("カラーを選択してください");
return false;
}
if (strOption==false){
alert("脚タイプを選択してください");
return false;
}



document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=valueCloth+"生地"
document.getElementById("choice3").value=valueColor
document.getElementById("choice4").value=valueOption+"脚"

//商品ページの有無チェック
var comcode=checkURL(strHaba,strCloth,strOption);
if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,strCloth,strOption);

if(!url){
alert("幅を入力してください");
return false;
}

var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_cloth.innerHTML=valueCloth;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice0").value="見積もり金額："+url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
    if(choice1=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }
    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a53354","40","magic","6na");
goods[1] =new setGoods("0000a53361","40","chappy","6na");
goods[2] =new setGoods("0000a53362","90","magic","6na");
goods[3] =new setGoods("0000a53369","90","chappy","6na");
goods[4] =new setGoods("0000a53370","120","magic","6na");
goods[5] =new setGoods("0000a53377","120","chappy","6na");
goods[6] =new setGoods("0000a53378","160","magic","6na");
goods[7] =new setGoods("0000a53385","160","chappy","6na");
goods[8] =new setGoods("0000a53386","190","magic","6na");
goods[9] =new setGoods("0000a53393","190","chappy","6na");





